

















import BaseComponent from "./BaseComponent.vue";
import { Focus } from '../directives/focus';
import { Vue, Component, Watch } from "vue-property-decorator";
import { WampProcedures } from '../lib/Controller/WampClient';
import { SessionState } from '../lib/Controller/State';
import { QForm } from 'quasar';
import _ from 'lodash';
import { Constants } from "../lib/Controller/Actions";
const ConstantStrings = require('../lib/constants/strings');
import Paths from '../lib/constants/paths';

@Component
export default class SSOLogin extends Vue {
  Paths = Paths;
  ConstantStrings = ConstantStrings;
  authenticated:boolean = false;

  created () 
  {
      this.isAuthenticated() 
      //this.$auth.loginRedirect('/')
  }

    async isAuthenticated () {
      this.authenticated = await (this as any).$auth.isAuthenticated()

      console.log(this.authenticated);
    }

    login () {
      (this as any).$auth.loginRedirect('')
    }

    async logout () {
      await (this as any).$auth.logout()
      await this.isAuthenticated()
    }

  mounted() {
    this.$q.dark.set(true);
  }
}
